import React, { useEffect } from "react";
import { Listing } from "./listing";

export const FavoriteListings = ({ listings = [], onAddToFavorites }) => {
  useEffect(() => {
    console.log("FavoriteListings rendered");
  }, [listings]);

  return (
    <div className="listings">
      <h4 className="listings__title">favorite listings</h4>
      <div className="listings__grid">
        {Array.isArray(listings) &&
          listings.map((listing, index) => (
            <Listing
              key={index}
              title={listing.title}
              price={Number(listing.price).toLocaleString("en-US", {
                style: "currency",
                currency: "JPY",
              })}
              size={listing.size || "-"}
              pictureUrl={listing.img}
              url={listing.url}
              favorited={true}
              onAddToFavorites={() => onAddToFavorites(listing)}
            />
          ))}
      </div>
    </div>
  );
};
